module.exports = __webpack_public_path__ + "static/media/MC Cao.c486ddea.png";